import Vue from 'vue'
import Vuex from 'vuex'

// lodash
import each from 'lodash/each.js'
import uniq from 'lodash/uniq.js'
import uniqBy from 'lodash/uniqBy.js'
import map from 'lodash/map.js'
import filter from 'lodash/filter.js'
import isEmpty from 'lodash/isEmpty.js'
import chunk from 'lodash/chunk.js'
import orderBy from 'lodash/orderBy.js'
import includes from 'lodash/includes.js'
import forOwn from 'lodash/forOwn.js'
import countBy from 'lodash/countBy.js'

var _ = { each, uniq, uniqBy, map, filter, isEmpty, chunk, orderBy, includes, forOwn, countBy }

Vue.use(Vuex)

function filterYears (state, vehicles) {
  if (state.searchFilters.year.length > 0) {
    vehicles = _.filter(vehicles, (car) => {
      if (_.includes(state.searchFilters.year, car.year)) {
        return car
      }
    })
  }
  return vehicles
}

function filterBodyType (state, vehicles) {
  if (state.searchFilters.body_type.length > 0) {
    vehicles = _.filter(vehicles, (car) => {
      if (_.includes(state.searchFilters.body_type, car.body_type)) {
        return car
      }
    })
  }
  return vehicles
}

export default new Vuex.Store({
  state: {
    searchFilters: {
    },
    pagination: {
      previousPage: 0,
      currentPage: 1,
      nextPage: 2,
      totalPages: 0,
      pageIndex: 0,
      perPage: 50
    },
    totalNumCars: null,
    cars: null,
    requestDate: '',
    carsFiltered: [],
    stockType: '',
    displayResults: false,
    viewFormat: '',
    status: []
  },
  mutations: {
    /**
     * Commit searchFilters to state
     * @param {object} state Vuex state object
     * @param {object} searchFilters
     */
    SET_SEARCH_FILTERS (state, searchFilters) {
      state.searchFilters = { ...state.searchFilters, ...searchFilters }
    },
    /**
     * commit filtered vehicles to state
     * @param {object} state
     * @param {object} filteredCars
     */
    SET_FILTERED_CARS (state, filteredCars) {
      state.carsFiltered = filteredCars
    },
    SET_PAGINATION (state, pagination) {
      state.pagination = pagination
    },
    SET_TOTAL_CARS (state, totalNumCars) {
      state.totalNumCars = totalNumCars
    },
    SET_SORT_BY (state, sortBy) {
      // state.searchFilters.sortBy = sortBy
    },
    SET_STOCK_TYPE (state, stockType) {
      state.stockType = stockType
    },
    SET_STATUS (state, status) {
      state.status = status
    },
    SET_CAR_INVENTORY (state, inventoryData) {
      state.cars = inventoryData.inventory
      state.requestDate = inventoryData.requestDate
    },
    SET_VIEW_FORMAT (state, viewFormat) {
      state.viewFormat = viewFormat
    }
  },
  actions: {
    /**
     * Prepare to commit searchFilters to state
     * @param {object} state Vuex state object
     * @param {object} searchFilters
     */
    storeSearchFilters (state, searchFilters) {
      this.commit('SET_SEARCH_FILTERS', searchFilters)
    },
    /**
     * Prepare to commit our filtered cars to state
     * @param {object} state
     * @param {object} filteredCars
     */
    storeFilteredCars (state, filteredCars) {
      this.commit('SET_FILTERED_CARS', filteredCars)
    },
    storePagination (state, pagination) {
      this.commit('SET_PAGINATION', pagination)
    },
    storeTotalNumCars (state, totalNumCars) {
      this.commit('SET_TOTAL_CARS', totalNumCars)
    },
    storeSortBy (state, sortBy) {
      this.commit('SET_SORT_BY', sortBy)
    },
    storeStockType (state, stockType) {
      this.commit('SET_STOCK_TYPE', stockType)
    },
    storeStatus (state, status) {
      this.commit('SET_STATUS', status)
    },
    storeCarInventory (state, inventoryData) {
      this.commit('SET_CAR_INVENTORY', inventoryData)
    },
    /**
     * Store user's view preference (grid or list?)
     * @param {Object} state
     * @param {String} viewFormat
     */
    storeViewFormat (state, viewFormat) {
      this.commit('SET_VIEW_FORMAT', viewFormat)
    }
  },
  getters: {
    allYears: function (state, getters) {
      let vehicles = {}
      const filters = {}

      // filter body_type
      if (state.searchFilters.body_type.length > 0) {
        _.each(state.searchFilters.body_type, bodyType => {
          filters.body_type = bodyType
        })
      }

      vehicles = _.filter(getters.getVehicles, filters)

      // get year of every vehicle
      const allYears = _.map(vehicles, 'year')

      // count number of times each year is listed
      const countedYears = _.countBy(allYears)

      // array container for storing our year data
      const returnYears = []

      // attach countedYears to our new array container
      for (var val in countedYears) {
        var year = `${val}`
        var count = `${countedYears[val]}`

        var yearObject = {
          year: year,
          count: count
        }

        returnYears.push(yearObject)
      }

      // sort the years (desc)
      returnYears.sort(function (a, b) { return b.year - a.year }).forEach(key => returnYears[key])

      // return our year data
      return returnYears
    },
    allBodyTypes: function (state, getters) {
      let vehicles = getters.getVehicles

      // filter year
      if (state.searchFilters.year.length > 0) {
        vehicles = filterYears(state, vehicles)
      }

      // get only body_type from vehicles
      const allBodyTypes = _.map(vehicles, 'body_type')

      // count, sory and return body_types
      return _.countBy(allBodyTypes.sort())
    },
    allMakes: function (state, getters) {
      let vehicles = getters.getVehicles
      const filters = {}

      // filter year
      if (state.searchFilters.year.length > 0) {
        vehicles = filterYears(state, vehicles)
      }

      // filter body_type
      if (state.searchFilters.body_type.length > 0) {
        vehicles = filterBodyType(state, vehicles)
      }

      const makes = _.map(_.filter(vehicles, filters), 'make')
      return _.countBy(makes.sort())
    },
    /**
     * Return an array of models for selected makes (all models if make is not selected)
     */
    allModels: function (state, getters) {
      var results = []
      var searchObject
      let vehicles = getters.getVehicles

      // filter year
      if (state.searchFilters.year.length > 0) {
        vehicles = filterYears(state, vehicles)
      }

      // filter body_type
      if (state.searchFilters.body_type.length > 0) {
        vehicles = filterBodyType(state, vehicles)
      }

      if (state.searchFilters.make.length > 0) {
        searchObject = state.searchFilters.make
      } else {
        searchObject = Object.keys(getters.allMakes)
      }

      _.each(searchObject, makeName => {
        _.filter(vehicles, function (car) {
          if (car.make === makeName) {
            results.push(car.model)
          }
        })
      })
      results.sort()
      results = _.countBy(results)

      // check if results is empty
      if (!Object.keys(results).length) {
        // No makes were selected. Show all models
        results = _.countBy(_.map(getters.getVehicles, 'model').sort())
      }

      return results
    },
    /**
     * getVehicles - retrieve vehicles for use in the SearchFilters
     * @param {Object} state
     * @returns {Object} filtered_vehicles
     */
    getVehicles: function (state) {
      const filters = {}

      if (state.stockType !== 'all') {
        // get all vehicles by stock_type
        filters.stock_type = state.stockType
      }

      // if a status box is checked (in-transit, in-stock), add to filter
      if (state.searchFilters.status_group.length > 0) {
        _.each(state.searchFilters.status_group, status => {
          if (status.length > 0) {
            filters.status_group = status
          }
        })
      }

      // if show_specials is checked, add to filter
      if (typeof (state.searchFilters.show_specials) !== 'undefined') {
        if (state.searchFilters.show_specials === '1') {
          filters.on_special = 'y'
        }
      }

      // if fresh is checked, add to filter
      if (typeof (state.searchFilters.fresh) !== 'undefined') {
        filters.fresh = 1
      }

      return _.filter(state.cars, filters)
    }
  },
  modules: {
  }
})
